module.exports = __webpack_public_path__ + "static/media/our-story-placeholder.c20583cf.webp";